import React from 'react';
import { FluidChatBot } from '../../fluidComponents/FluidChatBot/FluidChatBot.component';
export function ChatBotExamplePage() {
    return (React.createElement("div", null,
        React.createElement("h2", { className: "text-xl font-semibold text-slate-900 mb-2" }, "ChatBot"),
        React.createElement("p", { className: "text-slate-600 mb-6" }, "A generic chatbot powered by a simple AI agent. This example starts a fresh conversation that greets you and collects your name, email, and phone number."),
        React.createElement("div", { className: "border border-slate-200 rounded-xl overflow-hidden", style: { height: 500 } },
            React.createElement(FluidChatBot, { chatPanelTitle: "Assistant" }))));
}
